import { renderLiveDetails, renderLiveScore } from "../../../EventCard/RenderMethods";
export const renderLiveDetailsAmerican = (props, componentPrefix) => props.isDesktop
    ? props.event.isLive && renderLiveDetails(props, componentPrefix)
    : renderLiveScore(props.event, componentPrefix);
//# sourceMappingURL=renderLiveDetailsAmerican.js.map